import type { WorldInterface } from '@/types/worlds';
import { useBrowserList, type BrowserListConfig } from '@/composables/useBrowserList';

interface WorldBrowserConfig extends BrowserListConfig<WorldInterface> {
  onConfirm: (world: WorldInterface) => void;
}

// A world browser: the browser list, and confirming a world from it. The keyword slot it is
// handed is a shared one — the world list and the guided sources step write it from their own
// searches — which is why the list clears it on the way in as well as on the way out. (WorldBrowser
// empties its search box as it opens, to match.)
export function useWorldBrowser(config: WorldBrowserConfig) {
  const list = useBrowserList<WorldInterface>(config);

  const onSelect = (world: WorldInterface) => {
    list.selectedElement.value = world;
  };

  const onConfirm = (world: WorldInterface) => {
    config.onConfirm(world);
    list.close();
  };

  return { ...list, onSelect, onConfirm };
}
